import React from "react";
import { useContent } from "../context/ContentContext";

export default function Contact() {
  const { content } = useContent();
  const c = content.contact || {};
  return (
    <div className="container py-4">
      <h1 className="mb-4 text-success">{c.title || "Contact Us"}</h1>
      <form className="mb-4">
        <div className="mb-3">
          <label htmlFor="name" className="form-label">Name</label>
          <input type="text" className="form-control" id="name" required />
        </div>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">Email</label>
          <input type="email" className="form-control" id="email" required />
        </div>
        <div className="mb-3">
          <label htmlFor="message" className="form-label">Message</label>
          <textarea className="form-control" id="message" rows="4" required></textarea>
        </div>
        <button type="submit" className="btn btn-warning">Send Message</button>
      </form>
      <div className="mb-4">
        <h5 className="text-success">Contact Details</h5>
        <p>Phone: <a href={`tel:${(c.phone || "").replace(/\s/g, "")}`} className="text-warning">{c.phone}</a></p>
        <p>Email: <a href={`mailto:${c.email || ""}`} className="text-warning">{c.email}</a></p>
        <p>Business Hours: {c.businessHours}</p>
        <a href={`https://wa.me/${(c.phone || "").replace(/\D/g, "")}`} className="btn btn-success mt-2">WhatsApp Chat</a>
      </div>
      <div className="mb-4">
        <a href="https://www.google.com/maps" target="_blank" rel="noopener noreferrer" className="btn btn-outline-success">Open Google Maps</a>
      </div>
    </div>
  );
}
